import { Common, color } from '@stockbit/ui';
import { func, string } from 'prop-types';
import { useDispatch } from 'react-redux';
import { ButtonWidget, DeleteOptionWrapper } from '../styled';

import { effects } from './slice';

const { Flex, Text } = Common;

type PropTypes = {
  symbol: string;
  id: string;
  onClick: (e: MouseEvent) => void;
  onCancel: () => void;
  watchlistId: string;
};

const DeleteOption = ({
  id,
  symbol,
  onCancel,
  onClick,
  watchlistId,
  ...otherProps
}: PropTypes) => {
  const dispatch = useDispatch();
  const handleOnOk = (e) => {
    e.stopPropagation();
    // TODO: mas @hendra5, ini perlu dicek lagi terkait typingnya yap
    // @ts-ignore
    dispatch(effects.unfollowCompany({ companyId: id, watchlistId }));
    onCancel();
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    onCancel();
  }

  return (
    <DeleteOptionWrapper
      {...otherProps}
    >
      <Text as="span" size="11.5px" height="31px" width="50%" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', marginRight: '3px' }}>
        Confirm delete <b>{symbol}</b>
      </Text>
      <span />
      <Flex justify="flex-end" width="50%">
        <ButtonWidget type="sunsetOrange" height="30px" block onClick={handleOnOk}>
          <Text color={color.light} align="center">
            Yes
          </Text>
        </ButtonWidget>
        <ButtonWidget type="highempahis" height="30px" block onClick={handleCancel}>
          <Text color={color.light} align="center">
            No
          </Text>
        </ButtonWidget>
      </Flex>
    </DeleteOptionWrapper>
  );
};

DeleteOption.propTypes = {
  id: string.isRequired,
  symbol: string.isRequired,
  onCancel: func.isRequired,
};

export default DeleteOption;
